import { render, staticRenderFns } from "./PaddingLeftIcon.vue?vue&type=template&id=bb999a02&"
import script from "./PaddingLeftIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports